import { copy } from "./copy";

export async function getInvoiceLabels(): Promise<Record<string, string>> {
	const labelKeys = [
		"invoiceWebsite",
		"invoiceFooter1",
		"invoiceFooter2",
		"invoiceColumnEntryId",
		"invoiceColumnCategory",
		"invoiceColumnVertical",
		"invoiceColumnBrand",
		"purchaseOrderLabel",

		// Billed from
		"invoiceBusinessName",
		"invoiceBilledFrom1",
		"invoiceBilledFrom2",
		"invoiceBilledFrom3",
		"invoiceBilledFrom4",
		"invoiceBilledFrom5",
		"invoiceBilledFrom6",
		"invoiceBilledFrom7",
		"invoiceBilledFrom8",
		"invoiceBilledFrom9",
		"invoiceBilledFrom10",
		"invoiceBilledFrom11",
		"invoiceBilledFrom12",

		// Invoice Instructions
		"invoiceInstructions1",
		"invoiceInstructions2",
		"invoiceInstructions3",
		"invoiceInstructions4",
		"invoiceInstructions5",
		"invoiceInstructions6",
		"invoiceInstructions7",
		"invoiceInstructions8",
		"invoiceInstructions9",
		"invoiceInstructions10",
		"invoiceInstructions11",
		"invoiceInstructions12",
	];

	const values = await Promise.all(labelKeys.map((key) => copy(key)));
	return labelKeys.reduce(
		(acc, key, idx) => {
			acc[key] = values[idx];
			return acc;
		},
		{} as Record<string, string>,
	);
}

export async function getSubmissionLabels(): Promise<Record<string, string>> {
	const labelKeys = [
		// bank info
		"nameOnBankAccount",
		"bankAccountName",
		"bankAddress1",
		"bankAddress2",
		"bankCity",
		"bankState",
		"bankZipCode",
		"bankCountry",
		"bankAccountNumber",
		"bankRoutingNumber",
		"bankSwiftCode",
		"bankTransferNote",

		// check info
		"checkPayable",
		"checkAddress1",
		"checkAddress2",
		"checkCity",
		"checkState",
		"checkZipCode",
		"checkCountry",
		"checkPaymentNote",
	];

	const values = await Promise.all(labelKeys.map((key) => copy(key)));
	return labelKeys.reduce(
		(acc, key, idx) => {
			acc[key] = values[idx];
			return acc;
		},
		{} as Record<string, string>,
	);
}

export async function getFooterLabels(): Promise<Record<string, string>> {
	const labelKeys = [
		"footerAboutUs",
		"footerTermsAndConditions",
		"footerPrivacyPolicy",
		"footerPricingPolicy",
		"footerContactUs",
		"footerDisclaimer",
		"footerRefundPolicy",
		"footerCopyright",
		"footerBranding",
		"footerBrandingUrl",
	];

	const values = await Promise.all(labelKeys.map((key) => copy(key)));
	return labelKeys.reduce(
		(acc, key, idx) => {
			acc[key] = values[idx];
			return acc;
		},
		{} as Record<string, string>,
	);
}
